module.exports = __webpack_public_path__ + "static/media/icon-sort-white.9796c9a0.svg";